import { all, fork } from "redux-saga/effects";

import getGroupWatcher from "./appSagas/groups/get";
import listPricingLevelsWatcher from "./appSagas/pricingLevels/list";
import createPricingLevelWatcher from "./appSagas/pricingLevels/create";
import getPricingLevelWatcher from "./appSagas/pricingLevels/get";
import updatePricingLevelWatcher from "./appSagas/pricingLevels/update";


export default function* rootSagas(): Generator {
  yield all([
    fork(getGroupWatcher),
    fork(listPricingLevelsWatcher),
    fork(createPricingLevelWatcher),
    fork(getPricingLevelWatcher),
    fork(updatePricingLevelWatcher),
  ]);
}
